import React from "react";
import { ArrowRight } from "fe-shared/src/components/Icons";
import styles from "./ProcessingDirectionTitle.module.scss";

interface Props {
  from: string;
  to: string;
}

const ProcessingDirectionTitle = ({ from, to }: Props) => {
  return (
    <div className={styles.title}>
      <span>{from}</span>
      <ArrowRight fillColor="#63696F" />
      <span>{to}</span>
    </div>
  );
};

export default ProcessingDirectionTitle;
